export const API_URL = "https://api.trawlai.com/api/";
// export const API_URL = "http://localhost:8888/api/"
